<!-- filepath: /c:/Users/ACER/Documents/WebDev/booking/booking-frontend/src/App.vue -->
<template>
  <div id="app">
    <router-view />
  </div>

  <SocialFloat />

  <AppToast
    :visible="toast.visible.value"
    :type="toast.type.value"
    :title="toast.title.value"
    :message="toast.message.value"
    :duration="toast.duration.value"
    @close="closeToast"
  />
</template>

<script>
import AppToast from '@/components/common/Toast.vue'
import SocialFloat from '@/components/common/SocialFloat.vue'
import { ToastService } from '@/services/ToastService'

export default {
  name: 'App',
  components: {
    AppToast,
    SocialFloat
  },
  head: {
    link: [
      {
        rel: 'icon',
        href: require('./assets/logo.png')
      }
    ]
  },
  setup () {
    const toast = ToastService.getState()

    const closeToast = () => {
      ToastService.close()
    }

    return {
      toast,
      closeToast
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: 'Be Vietnam Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI',
    'Helvetica Neue', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #064e3b;
}

*, *::before, *::after {
  font-family: inherit;
}

button, input, select, textarea {
  font-family: inherit;
}
</style>
